import * as React from "react";
const SvgFiRrGalaxyPlanet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-galaxy-planet_svg__a)">
      <path
        fill="#062147"
        d="M3 2.5a1.5 1.5 0 1 1 3.001 0 1.5 1.5 0 0 1-3 0m-3 11C0 11.57 1.57 10 3.5 10S7 11.57 7 13.5 5.43 17 3.5 17 0 15.43 0 13.5m2 0c0 .826.673 1.5 1.5 1.5S5 14.326 5 13.5c0-.828-.673-1.5-1.5-1.5S2 12.672 2 13.5M17.5 21a1.5 1.5 0 1 0 .001 3 1.5 1.5 0 0 0 0-3m5-3a1.5 1.5 0 1 0 .001 3 1.5 1.5 0 0 0 0-3m1.5-5.812c0 .352-.185.691-.486.871a13 13 0 0 1-1.688.818A5.51 5.51 0 0 1 16.501 18a5.51 5.51 0 0 1-5.325-4.123 13 13 0 0 1-1.688-.818 1 1 0 0 1-.486-.856c0-.367.202-.72.525-.894.081-.044.741-.39 1.793-.651a5.51 5.51 0 0 1 5.182-3.66 5.51 5.51 0 0 1 5.182 3.66c1.055.261 1.716.61 1.792.65a1 1 0 0 1 .524.88m-10.999.223c1 .32 2.22.588 3.5.588s2.498-.269 3.498-.588A3.505 3.505 0 0 0 16.5 8.999a3.505 3.505 0 0 0-3.499 3.412m6.225 2.28a12.8 12.8 0 0 1-2.726.307 12.8 12.8 0 0 1-2.726-.307 3.495 3.495 0 0 0 5.452 0m-7.797 4.394c-3.883 2.698-7.52 3.657-8.846 2.33-.408-.407-.603-1.043-.582-1.892a1 1 0 0 0-.974-1.024c-.578-.024-1.012.422-1.025.975-.036 1.395.367 2.558 1.167 3.355.783.784 1.873 1.168 3.185 1.168 2.237 0 5.12-1.116 8.217-3.27a1 1 0 0 0-1.142-1.643zM6.315 9.162A1 1 0 0 0 7 9.43a1 1 0 0 0 .73-.314q.334-.355.684-.705c2.612-2.611 5.482-4.63 8.084-5.682 2.26-.913 4.1-.97 4.92-.148.661.66.764 1.957.29 3.646a1 1 0 0 0 1.925.54c.87-3.097.044-4.755-.802-5.601-1.448-1.45-3.964-1.553-7.083-.291-2.845 1.15-5.952 3.324-8.75 6.122q-.372.372-.727.749a1 1 0 0 0 .043 1.413z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-galaxy-planet_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGalaxyPlanet;
